import { useTranslation } from "react-i18next";

const APP_URLS: Record<string, string> = {
  en: "https://b2c.smid.ai",
  ru: "https://b2c-ru.smid.ai",
};

/**
 * Returns the app URL based on the current language.
 * EN → b2c.smid.ai
 * RU → b2c-ru.smid.ai
 */
export const useAppUrl = (): string => {
  const { i18n } = useTranslation();
  return APP_URLS[i18n.language] || APP_URLS.en;
};
